import { render, staticRenderFns } from "./EntityGroups.vue?vue&type=template&id=5899080a&scoped=true"
import script from "./EntityGroups.vue?vue&type=script&lang=js"
export * from "./EntityGroups.vue?vue&type=script&lang=js"
import style0 from "./EntityGroups.vue?vue&type=style&index=0&id=5899080a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5899080a",
  null
  
)

export default component.exports